import { v4 as uuidv4 } from "uuid";
import Photo1 from "../../images/Galleary/work/photo1.JPG";
import Photo2 from "../../images/Galleary/work/photo2.JPG";
import Photo3 from "../../images/Galleary/work/photo3.JPG";
import Photo4 from "../../images/Galleary/work/photo4.JPG";
import Photo5 from "../../images/Galleary/work/photo5.JPG";
import Photo6 from "../../images/Galleary/work/photo6.JPG";
import Photo7 from "../../images/Galleary/work/photo7.JPG";
import Photo8 from "../../images/Galleary/work/photo8.JPG";
import Photo9 from "../../images/Galleary/work/photo9.JPG";
import Photo11 from "../../images/Galleary/work/photo11.JPG";
import Photo12 from "../../images/Galleary/work/photo12.JPG";
import Photo13 from "../../images/Galleary/work/photo13.JPG";
import Photo14 from "../../images/Galleary/work/photo14.JPG";
import Photo15 from "../../images/Galleary/work/photo15.JPG";
import Photo16 from "../../images/Galleary/work/photo16.JPG";

const images = [
  {
    id: uuidv4(),
    src: Photo1,
    alt: "Перманентний макіяж бровей, крупний план",
  },
  {
    id: uuidv4(),
    src: Photo2,
    alt: "Результат роботи з перманентним макіяжу глаз",
  },
  {
    id: uuidv4(),
    src: Photo3,
    alt: "Перманентний макіяж бровей, крупний план",
  },
  {
    id: uuidv4(),
    src: Photo4,
    alt: "Процес навчання, мастер-клас",
  },
  {
    id: uuidv4(),
    src: Photo5,
    alt: "Процес навчання, мастер-клас",
  },
  {
    id: uuidv4(),
    src: Photo6,
    alt: "Процес навчання, мастер-клас",
  },
  {
    id: uuidv4(),
    src: Photo7,
    alt: "Процес навчання, мастер-клас",
  },
  {
    id: uuidv4(),
    src: Photo8,
    alt: "Процес навчання, мастер-клас",
  },
  {
    id: uuidv4(),
    src: Photo9,
    alt: "Процес навчання, мастер-клас",
  },
  {
    id: uuidv4(),
    src: Photo11,
    alt: "Процес навчання, мастер-клас",
  },
  {
    id: uuidv4(),
    src: Photo12,
    alt: "Процес навчання, мастер-клас",
  },
  {
    id: uuidv4(),
    src: Photo13,
    alt: "Процес навчання, мастер-клас",
  },
  {
    id: uuidv4(),
    src: Photo14,
    alt: "Процес навчання, мастер-клас",
  },
  {
    id: uuidv4(),
    src: Photo15,
    alt: "Процес навчання, мастер-клас",
  },
  {
    id: uuidv4(),
    src: Photo16,
    alt: "Процес навчання, мастер-клас",
  },
];

export default images;
